<mat-tab-group>

  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Master Data</span>
    </ng-template>
    <div class="content" role="main">
      <h2 i18n>Order Master Data</h2>
      <div class="card-container">
        <p class="card" (click)="onStatuses()">
          <mat-icon class="material-icons">assignment_turned_in</mat-icon>
          <span i18n>Statuses</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onTypes()">
          <mat-icon>assignment</mat-icon>
          <span i18n>Types</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onPriorities()">
          <mat-icon>assignment_late</mat-icon>
          <span i18n>Priorities</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
      </div>
    </div>
    <div class="content">
      <h2 i18n>Territory Master Data</h2>
      <div class="card-container">
        <p class="card" (click)="onAreas()">
          <mat-icon class="material-icons">map</mat-icon>
          <span i18n>Areas</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onBranch()">
          <mat-icon>corporate_fare</mat-icon>
          <span i18n>Branches</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onBranchAdmin()">
          <mat-icon>assignment_ind</mat-icon>
          <span i18n>Branch Admins</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
      </div>
    </div>
    <div class="content">
      <h2 i18n>Other Master Data</h2>
      <div class="card-container">
        <p class="card" (click)="onProductCategories()">
          <mat-icon class="material-icons">featured_video</mat-icon>
          <span i18n>Product Categories</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onFormTypes()">
          <mat-icon>description</mat-icon>
          <span i18n>Form Types</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onDepartments()">
          <mat-icon>hardware</mat-icon>
          <span i18n>Departments</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onChains()">
          <mat-icon>hub</mat-icon>
          <span i18n>Chains</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onChainAdmins()">
          <mat-icon>person_pin</mat-icon>
          <span i18n>Chain Managers</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onUserAttributes()">
          <mat-icon>manage_accounts</mat-icon>
          <span i18n>User Attributes</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
        <p class="card" (click)="onInstallationAttributes()">
          <mat-icon>real_estate_agent</mat-icon>
          <span i18n>Installation Attributes</span>
          <mat-icon class="material-icons">arrow_right</mat-icon>
        </p>
      </div>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Form Editor</span>
    </ng-template>
    <app-forms />
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Form Permissions</span>
    </ng-template>
 <app-forms-permissions />
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Sequential Order Actions</span>
    </ng-template>
    <app-sequential-order-actions />
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Configuration</span>
    </ng-template>
    <app-configuration />
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Library</span>
    </ng-template>
    <app-library />
  </mat-tab>
</mat-tab-group>

